import { CircularProgress, DialogActions } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Button } from "@mindlercare/ui-web";
import { useInvalidateSlots } from "components/booking/hooks/useInvalidateSlots";
import { Slot } from "../../../core/types";
import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useMutation } = ReactQueryV5;
import { useMindlerApi } from "../../../api/apiv2";
import { logger } from "core/logger";
import { ErrorText } from "./errorText";
import { useCloseDialog } from "./actions";

export const SlotDialogActions = ({ slot }: { slot: Slot }) => {
  const { t } = useTranslation();
  const invalidateSlots = useInvalidateSlots();
  const onClose = useCloseDialog(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const api = useMindlerApi();
  const { isPending: bookingInProgress, mutate: bookSlot } = useMutation(
    api.slots.psychologist.book.mutationOptions({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onSuccess: async (_data) => {
        await invalidateSlots();
        onClose();
      },
      onError: (error) => setErrorMessage(error.message),
    }),
  );

  const handleSave = async () => {
    if (!slot.userId) {
      logger.error("UserId unset in psychologist book", {
        slotId: slot.slotId,
      });
      setErrorMessage(t("ERROR_UNKNOWN"));
      return;
    }
    bookSlot({
      patientUserId: slot.userId,
      slotId: slot.slotId,
      method: slot.method ?? undefined,
    });
  };

  return (
    <>
      <DialogActionsContainer>
        <Button variant="secondary" onClick={onClose}>
          {t("CANCEL")}
        </Button>
        <Button
          variant="primary"
          testId="cy-confirm-booking"
          onClick={handleSave}
        >
          {t("BOOK_MEETING")}
        </Button>
        {bookingInProgress && <StyledCircularProgress />}
      </DialogActionsContainer>
      {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
    </>
  );
};

const DialogActionsContainer = styled(DialogActions)`
  flex-direction: row;
  align-self: flex-start;
  display: flex;
  padding: 24px 0 0 32px;
  margin: 0;
`;

const StyledCircularProgress = styled(CircularProgress).attrs({ size: 24 })`
  color: ${({ theme }) => theme.COLORS.PRIMARY};
`;
